import React, { useEffect, useState } from "react";

import Header from "./header";
import BrandList from "./brandlist";
import AlsoLikeList from "./alsoLikeList";
import RecommendedBrands from "./recommendedbrands";
import FAQ from "./faq";
import Footer from "./footer";

import { getCouponAPI, Offer } from "../utils/API";
import AdPage from "./AdPage";

function shuffleOffers(offers: Offer[]): Offer[] {
  const data = [...offers];
  for (let i = data.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [data[i], data[j]] = [data[j], data[i]];
  }
  return data;
}

function uniqueByStore(offers: Offer[], max: number): Offer[] {
  const seen = new Set<string>();
  const out: Offer[] = [];
  for (const offer of offers) {
    const storeKey = offer.store?.trim().toLowerCase();
    if (!storeKey || seen.has(storeKey)) continue;
    seen.add(storeKey);
    out.push(offer);
    if (out.length === max) break;
  }
  return out;
}

const PCTemplate: React.FC = () => {
  const [recommendedBrandsData, setRecommendedBrandsData] = useState<Offer[]>(
    [],
  );
  const [brandListData, setBrandListData] = useState<Offer[]>([]);
  const [alsoLikeListData, setAlsoLikeListData] = useState<Offer[]>([]);

  useEffect(() => {
    const loadData = async () => {
      const { result, offers } = await getCouponAPI();
      if (!result || offers.length === 0) return;

      const poolForRecommended = shuffleOffers(offers).slice(0, 50);
      // console.log("poolForRecommended ---->", poolForRecommended);

      setRecommendedBrandsData(uniqueByStore(poolForRecommended, 4));

      const poolForLists = shuffleOffers(offers);
      const thirty = uniqueByStore(poolForLists, 30);
      setBrandListData(thirty.slice(0, 20));
      setAlsoLikeListData(thirty.slice(20, 30));
    };
    loadData();
  }, []);

  return (
    <div className="relative w-full h-full flex flex-col justify-between bg-red-500">
      <Header />

      <AdPage />

      <main className="flex-1 w-full max-w-[1300px] mx-auto bg-red-500 h-auto">
        <div className="h-auto mx-auto">
          <div className="flex items-center justify-center">
            <div className="absolute z-0 top-[56px] md:top-[70px] w-full max-w-[1200px] mx-auto min-h-[265px] h-[244px] md:h-[400px]">
              <img
                src="/images/coupon-home-pc.png"
                alt=""
                className="w-full h-full object-contain opacity-70"
                loading="lazy"
                decoding="async"
                fetch-priority="auto"
                referrerPolicy="no-referrer"
                crossOrigin="anonymous"
                width="100%"
                height="100%"
              />
            </div>
          </div>
          <div className="w-full relative z-1 mt-[120px] md:mt-[280px] h-auto px-4">
            <RecommendedBrands recommendedBrandsData={recommendedBrandsData} />
            <BrandList brandListData={brandListData} />
            <AlsoLikeList alsoLikeListData={alsoLikeListData} />
            <FAQ />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PCTemplate;
